import { Avatar, Button, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import {
  B2CBackground,
  B2CLoginError,
  B2CLoginLogo,
  B2CLogo,
  B2CPhone,
  LeftArrow,
  RightArrowDatePicker,
} from 'Images';

export const DesktopUI = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.B2C);

  const onClickBack = () => {
    window.location.assign('/');
  };

  const onClickInfo = () => {
    window.location.assign('https://shikum.mod.gov.il/recognition/request');
  };

  return (
    <Stack
      sx={{
        backgroundImage: `url(${B2CBackground})`,
        backgroundSize: 'cover',
        height: '100vh',
        width: '100vw',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          width: '100%',
          maxWidth: '1000px',
        }}
      >
        <Stack
          sx={{
            bgcolor: 'primary.shade_100',
            maxWidth: '40%',
            height: '100%',
            borderTopLeftRadius: '24px',
            borderBottomLeftRadius: '24px',
            p: '40px 42px',
            alignItems: 'center',
          }}
        >
          <Avatar alt='' src={B2CLogo} sx={{ width: '40px', height: '41px' }} />
          <Typography mt='4px' variant='body1'>
            {dictionary.logo}
          </Typography>
          <Typography
            sx={{
              fontSize: '28px !important',
              fontWeight: '700',
              maxWidth: '19ch',
              mt: '48px',
            }}
            component='h1'
          >
            {dictionary.title}
          </Typography>
          <Avatar
            sx={{ width: '180px', height: '177px', m: '24px 0' }}
            alt=''
            src={B2CLoginLogo}
          />
          <Typography
            sx={{
              fontSize: '18px !important',
              fontWeight: '400 !important',
              maxWidth: '31ch',
            }}
          >
            {dictionary.explanation}
          </Typography>
          <Stack
            sx={{
              flexDirection: 'row',
              gap: '8px',
              mt: '44px',
              justifyContent: 'center',
            }}
          >
            <Avatar
              alt=''
              src={B2CPhone}
              sx={{ width: '32px', height: '32px' }}
            />
            <Typography
              sx={{ fontSize: '18px !important', fontWeight: '400 !important' }}
            >
              {dictionary.helpTextRight}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          sx={{
            bgcolor: 'white',
            maxWidth: '60%',
            height: '100%',
            borderTopRightRadius: '24px',
            borderBottomRightRadius: '24px',
            p: '40px 72px 34px',
            alignItems: 'center',
          }}
        >
          <Avatar
            alt=''
            src={B2CLoginError}
            sx={{ width: '142px', height: '97px' }}
          />
          <Typography
            sx={{
              fontSize: '28px !important',
              fontWeight: '700',
              mt: '24px',
            }}
            component='h1'
          >
            {dictionary.errorTitle}
          </Typography>
          <Typography mt='40px' variant='body3'>
            {dictionary.errorExplanation.line1}
          </Typography>
          <Typography variant='body3'>
            {dictionary.errorExplanation.line2}
          </Typography>
          <Stack
            sx={{ flexDirection: 'row', justifyContent: 'center', gap: '6px' }}
          >
            <Typography variant='body3'>
              {dictionary.errorExplanation.line3}
            </Typography>
            <Typography variant='body3' sx={{ color: '#1552E8' }}>
              {dictionary.errorExplanation.phoneNumber}
            </Typography>
          </Stack>
          <Button
            variant='outlined'
            sx={{
              width: '244px',
              height: '46px',
              mt: '72px',
              alignItems: 'center',
            }}
            onClick={onClickBack}
          >
            <Avatar
              alt=''
              src={RightArrowDatePicker}
              sx={{ width: '26px', height: '26px ' }}
            />
            <Typography variant='body4'>{dictionary.buttonLabel}</Typography>
          </Button>
          <Typography mt='103px' variant='body6'>
            {dictionary.helpTextLeft.line1}
          </Typography>
          <Stack
            sx={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <Link
              onClick={onClickInfo}
              underline='none'
              sx={{
                ':hover': {
                  cursor: 'pointer',
                  textDecoration: 'underline',
                },
              }}
            >
              <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                <Typography variant='body6'>
                  {`${dictionary.helpTextLeft.line2} ${dictionary.helpTextLeft.link}`}
                </Typography>
                <Avatar
                  alt=''
                  src={LeftArrow}
                  sx={{ width: '26px', height: '26px ' }}
                />
              </Stack>
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
